<template>
<div>
    <q-dialog v-model="editDialog">
        <q-card class="q-pt-md">
            <q-card-section class="q-pt-none">
                <virtual-field-edit
                    :entry="fieldEdit"
                    @create="closeEdit"
                    @save="closeEdit"
                    @remove="closeEdit"
                />
            </q-card-section>
        </q-card>
    </q-dialog>
    <h6>Virtual fields</h6>
    <p class="small">
        Create your own virtual fields for your organization needs.
    </p>

    <p>
        <q-btn label="Create" color="primary" @click="editDialog = true" />
    </p>

    <div class="table-responsive scrollbar" style="max-width: 850px;">
        <table class="table">
            <thead>
            <tr>
                <th scope="col">Labels</th>
                <th scope="col">Name</th>
                <th scope="col">Type</th>
                <th scope="col">Options</th>
                <th class="text-end" scope="col">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr :key="`v_field_${field.name}`" v-for="field in fields">
                <td>{{ field.label }}</td>
                <td>
                    <div class="text-nowrap badge badge-soft-dark">{{ field.name }}</div>
                </td>
                <td><div class="text-nowrap badge badge-soft-primary">{{ humanReadableType(field.type) }}</div></td>
                <td>
                    <div v-if="field.type === 'boolean'">
                        <div class="text-nowrap">1: True</div>
                        <div class="text-nowrap">0: False</div>
                    </div>
                    <div class="text-nowrap" :key="`v_field_${field.name}_option_${key}`" v-for="(option, key) in field.options">
                        {{option.key}}: {{ option.value }}
                    </div>
                </td>
                <td class="text-end">
                    <div>
                        <q-btn dense flat label="Edit" color="primary" @click="edit(field)" />
                    </div>
                </td>
            </tr>
            </tbody>
        </table>

    </div>


</div>
</template>

<script>
import VirtualFieldEdit from "./VirtualFieldEdit";
import {ref, watch,} from "vue";

export default {
    name: "VirtualFieldsManager",
    components: {VirtualFieldEdit},
    setup(){

        const fields = ref([]);
        const editDialog = ref(false);
        const fieldEdit = ref({});

        const loadFromServer = async () => {
            window['APIv2']._request('virtual-fields', {
                query: "",
                workspace_id: window['APIv2'].workspace.id,
            }).then((response) => {
                fields.value = response.data.map((field) => {

                    let options = [];
                    if(field.options instanceof Array){
                        options = field.options
                    }
                    if(field.options instanceof Object){
                        options = Object.keys(field.options).map((key) => {
                            return {
                                key: key,
                                value: field.options[key]
                            }
                        })
                    }

                    return {
                        ...field,
                        options: options
                    }
                });
            }).catch((err) => {console.log(err)})
        };

        const edit = (field) => {
            fieldEdit.value = field;
            editDialog.value = true;
        }

        const closeEdit = () => {
            editDialog.value = false;
            loadFromServer()
        }

        watch(editDialog, (newVal) => {
            if(!newVal){
                fieldEdit.value = {};
            }
        })



        if(window['APIv2']){
            loadFromServer()
        } else {
            window.addEventListener('APIv2Ready', () => {
                loadFromServer()
            })
        }

        return {
            edit,
            closeEdit,
            loadFromServer,
            fields,
            fieldEdit,
            editDialog,
        }
    },
    methods: {
        humanReadableType(type) {
            switch (type) {
                case 'boolean':
                    return 'Boolean (logical)';
                case 'multiple_select':
                    return 'Multiple select (checkboxes)';
                default:
                    return 'Unknown';
            }
        },
    },
}
</script>

<style scoped>

</style>
